import request from './request'

/**
 * 查询用户体检记录并关联评价记录状态
 * @returns 用户评价记录列表
 */
export function getRatingList() {
    return request.get('/api/rating/list')
}

/**
 * 查询用户评价记录详情
 * @param {体检编号} tjbh 
 * @returns 评价记录详情
 */
export function getRating(tjbh) {
    return request.get('/api/rating/record', {
        params: {
            tjbh: tjbh
        }
    })
}


export function saveRating(ratingData) {
    return request.post('/api/rating/save', ratingData);
}